"use client";
import React from "react";
import { usePathname } from "next/navigation";
import { ThemeSwitch } from "./ThemeChanger";
import Menus from "./Menu";
import MegaMenu from "./MegaMenu";
import Image from "next/image";
import Link from "next/link";
import MobileNav from "./MobileNav";

const navigation = [
  { name: "Home", href: "/" },  
  { name: "FAQs", href: "/FAQ" },
];

export default function Nav() {
  const pathname = usePathname();

  return (
    <header className="bg-customLightBlue bg-opacity-95 dark:bg-opacity-90 dark:bg-customGrey sticky inset-x-0 top-0 z-50">
      <nav
        className="flex items-center justify-around p-4 lg:px-20 font-cinzel"
        aria-label="Main navigation"
      >
        <div className="flex lg:flex-1 justify-center center">
          <Link href="/" className="flex" aria-label="Home">
            <Image
              className="h-auto w-12 sm:w-28"
              height={150}
              width={150}
              src="/logo.png"
              alt="Alpha Appraisals Logo"
              priority
            />
          </Link>
        </div>
        
        <div className="justify-center font-cinzel place-items-center lg:flex lg:gap-x-10">
          <div className="hidden lg:flex w-52 ml-12" role="navigation">
            {navigation.map((item) => (
              <Link
                key={item.name}
                href={item.href}
                aria-current={pathname === item.href ? "page" : undefined}
                className={`relative w-full text-black dark:text-blue-500 leading-6 text-lg pr-9 font-bold
                  before:w-full before:h-2 before:rounded before:origin-left before:transition-transform before:duration-300 before:scale-x-0 before:bg-blue-500 before:absolute before:left-0 before:top-0 before:transform before:rotate-[320deg] 
                  hover:text-lg hover:before:scale-x-100 hover:before:origin-left 
                  ${pathname === item.href ? "text-black dark:text-whte before:scale-x-100" : ""}`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>

        <Menus />

        <MegaMenu />

        <MobileNav />
        
        <div className="lg:flex lg:flex-1 justify-center center">
          <ThemeSwitch />
        </div>
      </nav>
    </header>
  );
}
